import { isPrepareModuleEnabled, isPrepareNativeModuleEnabled, } from '@office-start/ai-hub-config-service';
/* By default, the Prepare module has the MetaOS integration. However, this guard allows you to switch to the native NPM integration if needed using flighting. */
export var prepareRouteGuard = function (props) {
    var canActivate = isPrepareModuleEnabled(props.featureGates) &&
        isPrepareNativeModuleEnabled(props.featureGates);
    return { canActivate: canActivate };
};
//# sourceMappingURL=prepareRouteGuard.js.map